import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';

@Component({
    selector: 'app-predefined-use-cases',
    templateUrl: './predefined-use-cases.component.html',
    styleUrls: ['./predefined-use-cases.component.scss']
})
export class PredefinedUseCasesComponent {

    @Input() consentUseCases: ConsentUseCaseBasicModel[] | undefined;
    @Output() useCaseStepEvent: EventEmitter<ConsentUseCaseBasicModel> = new EventEmitter();

}
